import { Checkbox } from '@acpaas-ui/react-components';
import _ from 'lodash';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import TableSortButton from './TableSortButton';

const TableHead = ({
  resourceKey,
  headers = [],
  isLoading,
  isEmpty,
  disableSort = false,
  enableSelect = false,
  allSelected = false,
  onSelectAll = _.noop,
  type,
  sort,
  sortFunction = _.noop
}) => {
  if (!isLoading && isEmpty) {
    return null;
  }

  return (
    <thead className="spo-m-tablehead">
      <tr>
        {isLoading ? (
          <th>
            <Skeleton />
          </th>
        ) : (
          <>
            {enableSelect && (
              <th key={`${resourceKey}_select-all`} className="spo-m-tablehead__select-all">
                <Checkbox checked={allSelected} onChange={onSelectAll} />
              </th>
            )}
            {headers.map((h) => (
              <th key={`${resourceKey}_${h.value}`}>
                {!disableSort && !h.blockSort ? (
                  <TableSortButton type={type} label={h.label} value={h.value} onChange={sortFunction} sort={sort} />
                ) : (
                  h.label
                )}
              </th>
            ))}
          </>
        )}
      </tr>
    </thead>
  );
};

export default TableHead;
